import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { tabsDriverFactory } from '../Tabs/Tabs.driver';
import { TABBED_CONTENT_HOOKS } from './constants';

export const tabbedContentDriverFactory = (base: UniDriver) => ({
  ...tabsDriverFactory(base),
  getActiveContent: () => base.$(`[role=tabpanel]:not([hidden])`).text(),
  getTabContent: (index: number) =>
    base
      .$(`[data-hook="${TABBED_CONTENT_HOOKS.contentContainer}-${index}"]`)
      .text(),
});

export type TabbedContentDriver = ReturnType<typeof tabbedContentDriverFactory>;
